export class IEventAddOn {
  //
  add_on_id: string;
  quantity: number;

  fee?: number;
  title?: string;
  description?: string;
}
